import includes from 'lodash/includes';

function gstLabel(gst) {
  if (gst == 'inclusive') {
    return ' Inc. GST';
  } if (gst == 'exclusive') {
    return ' Exc. GST';
  }
  return '';
}

function salePriceToDisplay(salePrice) {
  let priceText = '';
  if (salePrice) {
    priceText += salePrice.display || '';
    priceText += gstLabel(salePrice.gst);
  }
  return priceText;
}

function leasePriceToDisplay(leasePrice) {
  let priceText = '';

  if (leasePrice) {
    priceText += leasePrice.display || '';

    if (leasePrice.range) {
      priceText += (` ${leasePrice.range}`);
    }
    priceText += gstLabel(leasePrice.gst);
  }

  return priceText;
}

export function price(detail) {
  let priceText = '';
  const salePriceText = salePriceToDisplay(detail['sale-price']);
  const leasePriceText = leasePriceToDisplay(detail['rental-price']);

  if (salePriceText == leasePriceText) {
    priceText += salePriceText;
  } else if (salePriceText && leasePriceText) {
    priceText += `${salePriceText} or ${leasePriceText}`;
  } else {
    priceText += salePriceText + leasePriceText;
  }

  return priceText;
}

export function status(listingStatus, newListing) {
  const validStatus = {
    'under-contract': 'Under Contract',
    sold: 'Sold',
    leased: 'Leased',
  };

  if (listingStatus != 'on-market') {
    return validStatus[listingStatus];
  } if (newListing) {
    return 'New';
  }
  return '';
}

export function channelLabel(availableChannels, channel) {
  if (includes(availableChannels, 'sold-leased')) {
    return channel;
  } if (includes(availableChannels, 'buy') && includes(availableChannels, 'rent')) {
    return 'For Sale or Lease';
  } if (includes(availableChannels, 'rent')) {
    return 'For Lease';
  }
  return 'For Sale';
}

export function omnitureChannel(channel) {
  const key = channel.toLowerCase();
  const channelMap = {
    buy: 'for sale',
    rent: 'for lease',
    sold: 'sold',
    leased: 'leased',
  };
  return channelMap[key];
}

export function queryChannel(channel) {
  const channelMap = ['buy', 'rent'];
  return includes(channelMap, channel) ? channel : '';
}

export function enquiryChannel(channel) {
  const key = channel.toLowerCase();
  const channelMap = {
    buy: 'buy',
    rent: 'rent',
    sold: 'sold',
    leased: 'sold',
  };
  return channelMap[key];
}

export function pdpChannel(_queryChannel, listingChannel) {
  return _queryChannel || listingChannel;
}

export function listingChannelToUrlChannel(listingChannel) {
  const channel = listingChannel.toLowerCase();
  const channelMap = {
    buy: 'for-sale',
    rent: 'for-lease',
    'for-sale': 'for-sale',
    'for-lease': 'for-lease',
    sold: 'sold',
    leased: 'leased',
  };
  return channelMap[channel];
}

export function mainPhoto(product, imageServer, imageUri) {
  const resolutionMapping = {
    premier: '500x500',
    elite: '400x300',
    featured: '144x192',
    standard: '144x130',
    undefined: 'raw',
  };

  return `${imageServer}/${resolutionMapping[product]}${imageUri}`;
}

export function generateMailToString(title, body) {
  return `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(body)}`;
}

export function generateShareToFacebookURL(url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

export function generateShareToTwitterURL(url, subjectLine) {
  return `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(subjectLine)}&hashtags=realcommercial`;
}

export function generateShareToMailSubject(address, channel) {
  const channelMap = {
    Buy: 'Commercial Real Estate For Sale',
    Rent: 'Commercial Real Estate For Lease',
    Sold: 'Sold and leased Commercial Real Estate',
    leased: 'Sold and leased Commercial Real Estate',
  };

  const channelInfo = channelMap[channel] ? channelMap[channel] : 'Commercial Real Estate For Sale';
  return `${channelInfo} in ${address.suburb || ''}, ${address.state ? address.state.toUpperCase() : ''} ${address['post-code'] || ''}`;
}

export function generateShareToMailBody(title, url) {
  return `Hi,\n\nI think you might be interested in this property ${title}: ${url}`;
}
